export const INBOX_GROUPS = [
  { label: 'All', key: 'all', dot_class: 'bg-success' },
];

export const PINNED_INBOX_GROUPS = [
  { label: 'Mentions', key: 'mentions', dot_class: 'bg-success' },
];

export const TRAILING_INBOX_GROUPS = [
  { label: 'SLA & risk', key: 'sla-risk', dot_class: 'bg-danger' },
  { label: 'Messages', key: 'messages', dot_class: 'bg-dark' },
];

export const TASK_GROUPS = [
  { label: 'Due today', key: 'today', dot_class: 'bg-warning' },
  { label: 'This week', key: 'week', dot_class: 'bg-light border' }
];

export const SLA_WARNING_TOKENS = ['left', 'warning', 'at-risk', 'due'];
export const SLA_BREACH_TOKENS = ['overdue', 'breach', 'breached', 'escalated'];
export const EVIDENCE_TOKENS = ['evidence', 'document', 'verification', 'supporting'];
export const APPROVAL_TOKENS = ['approval', 'approve', 'authorisation', 'authorization', 'sign-off', 'decision'];
export const MESSAGE_TOKENS = ['message', 'reply', 'query', 'comment', 'note'];
export const MENTION_TOKENS = ['mention', 'mentioned', '@'];
